module.exports = __webpack_public_path__ + "img/blue_051.22359f31.png";